import { useParams } from 'react-router-dom'

import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { selectConsultationById, selectParticipantsByConsultationId } from '@/redux/reducers/consultation.reducer'
import { selectUnreadMessagesByChatRoom } from '@/redux/reducers/chat-room.reducer'

export function useConsultationData() {
  const { consultationId } = useParams()
  const authUser = useAppSelector(selectAuthUser)
  const consultation = useAppSelector((state) => (consultationId ? selectConsultationById(state, consultationId) : undefined))
  const participants = useAppSelector((state) => (consultationId ? selectParticipantsByConsultationId(state, consultationId) : undefined))
  const unreadChatMessages = useAppSelector((state) => (consultation?.chatRoom ? selectUnreadMessagesByChatRoom(state, consultation.chatRoom) : []))

  return {
    consultationId,
    authUser,
    consultation,
    participants,
    unreadChatMessages,
  }
}
